const mutations = {
  setTaxonomy(state, data) {
    state.taxonomy = data;
  },
  filterTaxonomy(state,data) {
    //our object sorting function goes here
  },
  apiFailure: (context, err) => {
      // alert("ERROR" + err);
      console.log(err);
  }
};

const actions = {
};

const getters = {
};

const state = {
  demographics: [],
  taxonomy: [],
};

export default {
  namespaced: true,
  actions,
  getters,
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/system.js